class ContainerPackingResult {
	constructor(ContainerID) {
		this.AlgorithmPackingResults = [];
		this.ContainerID = ContainerID;
	}
}

export default ContainerPackingResult;